import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { DefaultLayoutComponent } from './pages/default-layout/default-layout.component';
import { loginGuard } from './core/guards/login.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'company-information', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./pages/login/login.component').then(
        (login) => login.LoginComponent,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password.component').then(
        (forgot) => forgot.ForgotPasswordComponent,
      ),
  },
  {
    path: 'create-new-password',
    loadComponent: () =>
      import('./pages/create-new-password/create-new-password.component').then(
        (newPassword) => newPassword.CreateNewPasswordComponent,
      ),
  },
  {
    path: 'create-new-account',
    loadComponent: () =>
      import('./pages/add-new-account/add-new-account.component').then(
        (account) => account.AddNewAccountComponent,
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    component: DefaultLayoutComponent,
    children: [
      {
        path: 'company-information',
        loadComponent: () =>
          import('./pages/company/company.component').then(
            (company) => company.CompanyComponent,
          ),
      },
      {
        path: 'drivers',
        loadComponent: () =>
          import('./pages/drivers/drivers.component').then(
            (drivers) => drivers.DriversComponent,
          ),
      },
      {
        path: 'OperatingAuthorities/:oaid/documents/:id',
        loadComponent: () =>
          import(
            './pages/operatingAuthorities/events/event-documents/event-documents.component'
          ).then((documents) => documents.EventDocumentsComponent),
      },
      {
        path: 'OperatingAuthorities/:oaid/returning-guests/:id',
        loadComponent: () =>
          import(
            './pages/operatingAuthorities/events/returning-guests/returning-guests.component'
          ).then((guests) => guests.ReturningGuestsComponent),
      },
      {
        path: 'OperatingAuthorities/:oaid/vehicles/:id',
        loadComponent: () =>
          import(
            './pages/operatingAuthorities/operatingAuthorities.component'
          ).then((permits) => permits.OperatingAuthoritiesComponent),
      },
      {
        path: 'OperatingAuthorities/:oaid',
        loadComponent: () =>
          import(
            './pages/operatingAuthorities/operatingAuthorities.component'
          ).then((permits) => permits.OperatingAuthoritiesComponent),
      },
      {
        path: 'OperatingAuthorities',
        loadComponent: () =>
          import(
            './pages/operatingAuthorities/operatingAuthorities.component'
          ).then((permits) => permits.OperatingAuthoritiesComponent),
      },
      {
        path: 'OperatingAuthorityApplication/:oaaid',
        loadComponent: () =>
          import(
            './pages/operatingAuthorityApplication/operating-authority-application.component'
          ).then(
            (operatingAuthority) =>
              operatingAuthority.OperatingAuthorityApplicationComponent,
          ),
      },
      {
        path: 'OperatingAuthorityApplication/:oaaid/vehicles/:id',
        loadComponent: () =>
          import(
            './pages/operatingAuthorityApplication/operating-authority-application.component'
          ).then(
            (operatingAuthority) =>
              operatingAuthority.OperatingAuthorityApplicationComponent,
          ),
      },
      {
        path: 'OperatingAuthorityApplication',
        loadComponent: () =>
          import(
            './pages/operatingAuthorityApplication/operating-authority-application.component'
          ).then(
            (operatingAuthority) =>
              operatingAuthority.OperatingAuthorityApplicationComponent,
          ),
      },
      {
        path: 'help',
        loadComponent: () =>
          import('./pages/help-support/help-support.component').then(
            (helpSupport) => helpSupport.HelpSupportComponent,
          ),
      },
      {
        path: 'download-documents',
        loadComponent: () =>
          import(
            './pages/download-documents/download-documents.component'
          ).then(
            (downloadDocument) => downloadDocument.DownloadDocumentsComponent,
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import(
            './pages/commonPages/notifications/notifications.component'
          ).then((notifications) => notifications.NotificationsComponent),
      },
      {
        path: 'comments',
        loadComponent: () =>
          import(
            './pages/commonPages/comments-tab/comments-tab.component'
          ).then((comments) => comments.CommentsTabComponent),
      },
      {
        path: 'notification-details/:id',
        loadComponent: () =>
          import(
            './pages/commonPages/notifications/notification-details/notification-details.component'
          ).then(
            (notificationDetails) =>
              notificationDetails.NotificationDetailsComponent,
          ),
      },
      {
        path: 'comment-details/:id',
        loadComponent: () =>
          import(
            './pages/commonPages/comments-tab/comment-details/comment-details.component'
          ).then((commentDetails) => commentDetails.CommentDetailsComponent),
      },
    ],
  },
  {
    path: 'pageNotFound',
    loadComponent: () =>
      import('./pages/page-not-found/page-not-found.component').then(
        (page) => page.PageNotFoundComponent,
      ),
  },
  { path: 'login', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'pageNotFound' },
];
